import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getFormattedDuration } from '../utils/helpers';

const TotalTime = styled.span`
	margin-right: 8px;
	font-size: var(--adm-font-size-5);
`;

function TotalTimeComponent({ workEntry }) {
	const [currentDuration, setCurrentDuration] = useState(0);
	const [intervalId, setIntervalId] = useState(null);

	useEffect(() => {
		if (workEntry) {
			const interval = setInterval(() => {
				const diffTime = moment().diff(workEntry.work_start);
				const duration = moment.duration(diffTime).asMilliseconds();
				setCurrentDuration(duration);
				setIntervalId(interval);
			}, 1000);
		} else {
			setCurrentDuration(0);
			clearInterval(intervalId);
		}

		return () => clearInterval(intervalId);
	}, [workEntry]);

	return <TotalTime>{getFormattedDuration(currentDuration, true)}</TotalTime>;
}

export default TotalTimeComponent;
